module.exports = __webpack_public_path__ + "static/media/Banner-Image.3bad2b78.jpg";